import totusBuLogo from "../images/tottusBuLogo.svg";
import fComBuLogo from "../images/fComBuLogo.svg";
import falabellaBuLogo from "../images/falabellaBuLogo.svg";
import sodimacBuLogo from "../images/sodimacBuLogo.svg";
import maestroBuLogo from "../images/maestro_bu.svg";

export const buLogoImgaeMapping = {
  Tottus: totusBuLogo,
  Falabella: falabellaBuLogo,
  Sodimac: sodimacBuLogo,
  Maestro: maestroBuLogo,
  ["Falabella.com"]: fComBuLogo,
};

export const checkContentAvlInArray = (a1, a2) => {
  return a1.some((val) => a2.indexOf(val) !== -1);
};

// export const dataDashboard = (data) => {
//   if (window && window.s) {
//     for (const [key, value] of data) {
//       window.s[`${key}`] = `${value}`;
//     }
//     window.s.tl();
//   }
// };

export const pickStartTimeOnly = (data) => {
  const tempArray = data.split(" ");
  const startTimeOnly = tempArray.slice(0, 2);
  return startTimeOnly.join(" ");
};

export const getCountrySet = (data) => {
  const countries = [];
  const locations = [];
  const subLocations = {};
  const countryByLocation = {};
  const bu = {};
  data.countries.forEach((country) => {
    countries.push({label: country.code, value: country.code});
    country.locations.forEach((location) => {
      locations.push({label: location.name, value: location.name});
      bu[location.name] = location.businessUnits?.map((businessUnit) => {
        return {label: businessUnit, value: businessUnit};
      });
      countryByLocation[country.code] = countryByLocation[country.code]?.length
        ? countryByLocation[country.code]
        : [];
      countryByLocation[country.code].push({
        label: location.name,
        value: location.name,
      });
      subLocations[location.name] = location.subLocations?.map(
        (subLocation) => {
          return {label: subLocation, value: subLocation};
        }
      );
    });
  });
  return {countries, bu, locations, subLocations, countryByLocation};
};

export const createDropdownCompatibleData = (data) => {
  const toReturn = data?.map((x) => {
    return {label: x, value: x};
  });
  return toReturn;
};

export const createDropdownCompatibleStoreData = (data) => {
  const toReturn = data?.map((x) => {
    return {...x, label: x.storeName, value: x.uuid};
  });
  return toReturn;
};

export const createDropdownCompatibleServiceData = (data) => {
  const toReturn = data?.map((x) => {
    return {...x, label: x.serviceType, value: x.uuid};
  });
  return toReturn;
};

export const createTurneroDropdownCompatibleStoreData = (data) => {
  const toReturn = data?.map((x) => {
    return {...x, label: x.name, value: x.uuid};
  });
  return toReturn;
};

export const getValueFromArrOfObj = (options, needed) => {
  return options?.map((value) => {
    return value[needed];
  });
};
